module.exports = __webpack_public_path__ + "static/media/9.3fd7c3db.jpg";